export default "__VITE_ASSET__5e0e6930__"